import { SpaceNode } from '.';
import { IgnoreChanges } from '../decorators/change-tracker';
import { Kb3dModel } from '../decorators/kb3d-decorator';
import { IMeshNode } from '../kb3d-models';
import { KbGeometry } from '../primitives/kb-geometry';
import { Token } from '../token';
import { MeshNode } from './mesh-node';

/**
 * A Mesh Node. Must be a descendant of the MeshRoot node.
 * @param {Object} nodeConfig The configuration object of the node.
 * @param {string} nodeConfig.name The name of the node. Required.
 * @param {Object} parent The parent of this node. Optional, but mesh nodes should have parents if they are to be displayed.
 * @property
 */

@Kb3dModel<CustomMeshNode>({
    token: Token.CustomMeshNode,
})
export class CustomMeshNode extends MeshNode implements IMeshNode {
    constructor() {
        super();
    }

    /** Loading state of mesh. Used to keep track of when a request is in flight */
    @IgnoreChanges
    public _loading: string | null = null;

    /** The mesh geometry ID. Blank string is there is no geometry, otherwise is the same as the geometry.id */
    public geometryId: string;

    /** The mesh geometry. Undefined if not loaded or doesn't exist. Should be lazy loaded using the geometryId property. */
    public _geometry?: KbGeometry;

    get hasGeometry() {
        return this.geometryId != null && this.geometryId != '';
    }
    get geometryLoaded() {
        return this._geometry != null;
    }

    copyPropertiesTo(target: SpaceNode) {
        super.copyPropertiesTo(target);
        if (target instanceof CustomMeshNode) {
            target.geometryId = this.geometryId;
        }
    }
}
